import { ThermometerMinusIcon } from './ThermometerMinusIcon';

/**
 * author: Michael Richins
 * id 310F50E9-D74E-4753-A6D8-60EDBFC332B7
 * name thermometer-minus
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thermometer-minus.svg
 * tags
 * - Home Automation 
 * - Weather 
 */
export const TemperatureMinusIcon = ThermometerMinusIcon;
export default TemperatureMinusIcon